module.exports = __webpack_public_path__ + "img/ico_group_arrow.7021da4f.svg";